import React from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import {
    Card,
    Col,
    Row,
    Typography,
    Divider, 
    Button, 
    Form,
    notification
} from "antd";
import { FaUser, FaLock } from "react-icons/fa";
import styles from "./login.module.css";
import CustomInput from "../common/CustomInput/CustomInput";

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { LoginHelper } from "../../helper";

const { Title, } = Typography;

const Login = ({ setIsLogin }) => {
    const { search } = useLocation();
    const makcb = new URLSearchParams(search).get("makcb");
    const maCoSoKcb = new URLSearchParams(search).get("mandk");


    const onFinish = async (values) => {

        console.log('values', values);

        const l = await LoginHelper(values)

        if (!l) {
            notification.error({ message: "Thông báo", description: "Tên đăng nhập/mật khẩu không đúng" })
            return;
        }


        setIsLogin(l)
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (
        <Card
            className={styles.loginCard}
        >
            <Row
                justify="center"
                align="middle"
                className={styles.loginRow}
            >
                <Col xs={24} sm={16} md={12} lg={10}>
                    <Title level={3} className={styles.loginTitle}>
                        Đăng nhập
                    </Title>
                    <Divider className={styles.loginDivider} />
                    <Form
                        name="basic"
                        className={styles.loginForm}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        initialValues={{ username: makcb, maCoSoKcb: maCoSoKcb }}
                    >
                        <Form.Item
                            label="Tên đăng nhập"
                            name="username"
                            className={styles.formItem}
                            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập!' }]}
                        >
                            <CustomInput
                                placeholder="Nhập tên đăng nhập"
                                prefix={<FaUser />}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Mật khẩu"
                            name="password"
                            className={styles.formItem}
                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
                        >
                            <CustomInput
                                type="password"
                                placeholder="Nhập mật khẩu"
                                prefix={<FaLock />}
                            />
                        </Form.Item>
                        
                        <Form.Item
                            name="maCoSoKcb"
                            noStyle
                        >
                            <CustomInput
                                type="hidden"
                                value={maCoSoKcb}
                            />
                        </Form.Item>

                        <Form.Item className={styles.submitItem}>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                block
                                className={styles.submitButton}
                            >
                                Đăng nhập
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Card>
    );
};

export default Login;
